import { Button, Stack, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Toast } from "../components/Toast";
import { updateVehicleExpense } from "./httpCalls";

function UpdateEntry({ onClose, _id }) {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    checkOut: 0,
  });
  const handleInput = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };
  const submit = () => {
    if (!state.checkOut) {
      Toast("info", "Kinldy add Check Out");
      return;
    }
    onClose();
    updateVehicleExpense(_id, state.checkOut, dispatch);
  };
  return (
    <Stack>
      <Typography variant="h6" sx={{ color: "#4eaf51", margin: "20px, 0px" }}>
        Update Entry
      </Typography>
      <TextField
        variant="outlined"
        fullWidth
        size="small"
        type="number"
        label="Check Out"
        name="checkOut"
        value={state.checkOut}
        onChange={handleInput}
      />
      <Stack
        width="100%"
        direction="row"
        justifyContent="space-around"
        margin="3% 0px"
      >
        <Button
          sx={{
            width: "25%",
            color: "#A7A7A7",
            background: "#F8F8F8 !important",
          }}
          variant="contained"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button sx={{ width: "25%" }} variant="contained" onClick={submit}>
          Save
        </Button>
      </Stack>
    </Stack>
  );
}

export default UpdateEntry;
